(function () {
    'use strict';

    angular.module("imApp").factory("orderHeadDeleteOlService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1686,
                    parameters: parms || {}
                });
            },
            listDeleteOrderLines: function (parms) {
                return $ihttp.post({
                    method: 1687,
                    parameters: parms || {}
                });
            },
            deleteItems: function (items) {
                return $ihttp.post({
                    method: 1688,
                    parameters: items
                });
            }
        };

        return service;
    }]);
})();
